import { t } from 'i18next';

import { showConfirmDialog } from './messageDialog';
import { setLoadingState } from './progressIndicator';
import { MessageDialogTypes } from '../components/MessageDialog/MessageDialog';
import { UNAUTHORIZED_HTTP_CODE } from '../service/Error';
import { showModal, TYPES } from './modal';

const UPDATE_DEFECTS_STATUS = 'UPDATE_DEFECTS_STATUS';

function downloadDefects(ids) {
    return (dispatch, getState, { apiManager }) => {
        return ids.reduce((promise, id) => {
            return promise.then((res) => {
                return apiManager
                    .downloadDefectFile(id)
                    .then(() => {
                        res.downloaded.push(id);

                        return res;
                    })
                    .catch((err) => {
                        console.log(err);
                        res.errors.push(id);

                        return res;
                    });
            });
        }, Promise.resolve({ downloaded: [], errors: [] }));
    };
}

function downloadDefect(id, name) {
    return (dispatch, getState, { apiManager }) => {
        dispatch(setLoadingState(true, t('messages.downloadDefects', { name })));

        return apiManager
            .downloadDefectFile(id)
            .then(() => {
                dispatch({ type: UPDATE_DEFECTS_STATUS, data: { downloaded: [id] } });
                dispatch(setLoadingState(false));
            })
            .catch((err) => {
                if (err.errorCode === UNAUTHORIZED_HTTP_CODE) {
                    dispatch(setLoadingState(false));
                    dispatch(showModal(TYPES.RELOGIN, {}));
                    return;
                }

                dispatch(
                    showConfirmDialog({
                        title: t('errMessage'),
                        message: t('errors.uploadDocument'),
                        btnCancelVisibility: false,
                        options: {
                            type: MessageDialogTypes.ERROR,
                        },
                    })
                );
                dispatch(setLoadingState(false));
            });
    };
}

function downloadAllDefects(ids) {
    return (dispatch) => {
        dispatch(setLoadingState(true, t('messages.downloadDocuments')));
        return Promise.all([dispatch(downloadDefects(ids))])
            .then(([data]) => {
                dispatch({ type: UPDATE_DEFECTS_STATUS, data: data });
                if (data.errors.length || data.errors.length) {
                    // // Cannot re-open Dialog immediately, need timeout fro it
                    // setTimeout(() =>{
                    dispatch(
                        showConfirmDialog({
                            title: t('errMessage'),
                            message: t('errors.uploadDocuments'),
                            btnCancelVisibility: false,
                            options: {
                                type: MessageDialogTypes.ERROR,
                            },
                        })
                    );
                    // }, 1000)
                }
                dispatch(setLoadingState(false));
            })
            .catch(() => {
                dispatch(setLoadingState(false));
                // throw new Error('Failed to load documents from the server. Please try again later!');
            });
    };
}

export { UPDATE_DEFECTS_STATUS, downloadAllDefects, downloadDefect };
